import { useEffect, useState } from 'react';

export const useVisibilityChange = (): boolean => {
  const [visible, setVisible] = useState(true);

  const visibilityListener = (): void => {
    if (document.visibilityState === 'visible') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', visibilityListener);
    return (): void => {
      document.removeEventListener('visibilitychange', visibilityListener);
    };
  }, []);

  return visible;
};
